<div style="padding-top: 30px; padding-bottom: 10px; ">
    <p class="mat-headline-3">
        Data Processing Agreement (DPA)
    </p>
</div>

<div mat-dialog-content style="margin-left: 40px; margin-top: 0px" class="mat-typography">

    <p mat-body>Effective Date: July 1st, 2024<br />Last updated: October 18th, 2026 (Anthropic added as a sub-processor)</p>

    <p mat-body>This Data Processing Agreement (“Agreement”) forms part of the Terms of Use entered into between the
        Customer (“Controller”) and Coburn Social Enterprise, trading as OurOMC.ie (“Processor”).</p>

    <p class="mat-headline-4">1. Purpose</p>
    <p mat-body>This Agreement sets out the terms on which the Processor will process personal data on behalf of the
        Controller in connection with the Controller’s use of the OurOMC.ie software (“Software”).</p>

    <p class="mat-headline-4">2. Roles and Responsibilities</p>
    <p mat-body>The Controller determines the purposes and means of processing personal data.</p>
    <p mat-body>The Processor acts solely on the documented instructions of the Controller, which are established via
        the configuration and access controls within the Software.</p>

    <p class="mat-headline-4">3. Nature and Scope of Processing</p>
    <p mat-body><strong>Subject Matter:</strong> The Processor provides a SaaS platform for managing residential and/or commercial developments composed of multiple units.</p>
    <p mat-body><strong>Duration:</strong> Processing is carried out for the term of the license and up to 7 years
        thereafter in accordance with the Privacy Policy.</p>
    <p mat-body><strong>Types of Data:</strong> May include user names, contact details, ownership data, financial
        transactions, communications, service requests and any other data entered by users.</p>
    <p mat-body><strong>Data Subjects:</strong> OMC members, residents, suppliers, agents, and any other stakeholders whose
        data is entered into the Software.</p>

    <p class="mat-headline-4">4. Obligations of the Processor</p>
    <p mat-body>The Processor shall:</p>
    <ul>
        <li>Process personal data only on the Controller’s documented instructions;</li>
        <li>Implement appropriate technical and organisational measures to ensure data security;</li>
        <li>Ensure all staff handling personal data are subject to confidentiality obligations;</li>
        <li>Assist the Controller with GDPR compliance, including data subject rights and breach notifications. The processor reserves the right to charge a resonable fee for assistance in this regard, based on the additional support time required over and above standard operational support.</li>
        <li>Make available information and cooperation necessary for audits or inspections.</li>
    </ul>

    <p class="mat-headline-4">5. Sub-Processors</p>
    <p mat-body>The Processor may engage sub-processors to support the delivery of the service. Current sub-processors
        include:</p>
    <ul>
        <li><a href="https://www.digitalocean.com/legal/data-processing-agreement">Digital Ocean (Hosting)</a></li>
        <li><a href="https://postmarkapp.com/dpa">Postmark (Email delivery)</a></li>
        <li><a href="https://gocardless.com/open-banking/">GoCardless (Bank data access)</a> governed under <a href="https://eur-lex.europa.eu/eli/dir/2015/2366/oj">PSD2 Regulations for AISP Providers</a></li>
        <li><a href="https://www.anthropic.com/legal/data-processing-addendum">Anthropic (AI assistant)</a></li>
    </ul>

    <p mat-body>The Software's AI features, such as help with answering service requests, pass the data needed for
        each task to Anthropic. They are on by default. The Controller can switch them off by setting the AI Level
        to None.
        Under <a href="https://www.anthropic.com/legal/commercial-terms">Anthropic's commercial terms</a>,
        Anthropic may not train its models on this data.</p>

    <p mat-body>The Controller will be notified of changes to sub-processors upon request, otherwise they can check back to this page for the latest update of sub processors. 
        All sub-processors are subject to equivalent data protection obligations.</p>

    <p class="mat-headline-4">6. Data Retention</p>
    <p mat-body>Data will be retained for the duration of the service and for a period of up to 7 years thereafter,
        unless deletion is requested earlier by the Controller. Deletion services are available on request.</p>

    <p class="mat-headline-4">7. International Transfers</p>
    <p mat-body>The Processor will only transfer personal data outside the EEA where adequate safeguards exist, such as
        <a href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj">Standard Contractual Clauses (SCCs)</a>.
        Postmark and Anthropic process data in the United States under the SCCs incorporated in their data processing
        agreements: <a href="https://postmarkapp.com/dpa">Postmark DPA</a>,
        <a href="https://www.anthropic.com/legal/data-processing-addendum">Anthropic DPA</a>.</p>

    <p class="mat-headline-4">8. Audit Rights</p>
    <p mat-body>
        The Controller may request documentation reasonably necessary to demonstrate the Processor’s compliance with this Agreement, 
        provided the Controller can demonstrate a legitimate need for such documentation due to external regulatory, 
        legal, or contractual obligations. The Processor shall cooperate with such requests, 
        provided they are proportionate and do not unreasonably interfere with its operations. 
        Any audits shall be subject to reasonable notice, conducted during normal business hours, 
        and may be subject to a separate agreement and fee to cover associated costs. 
        The Processor may restrict access to sensitive or proprietary information and may require appropriate confidentiality 
        undertakings.</p>

    <p class="mat-headline-4">9. Governing Law</p>
    <p mat-body>This Agreement is governed by Irish law and is subject to the dispute resolution terms set out in the
        Terms of Use.</p>

    <p mat-body>By accepting the Terms of Use, the Controller agrees to the terms of this Data Processing Agreement.</p>

</div>